import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/SettingsOutlined";
import Tooltip from "../../common/StyledToolTip";
import styles from "../headerStyles";
import Button from "@material-ui/core/Button";
import Notifications from "./Notifications/index";
import HelpMenu from "../../common/HelpMenu";
import WatchTutorial from "../../InAppTutorial/WatchTutorial";
import TerminalMenu from "./../common/TerminalMenu";

class RightNavigationMenu extends React.Component {
  constructor(props) {
    super(props);
  }
  openDynamicRoutingModal = () => {
    if (this.disbaleDynamicRouting) {
      return false;
    }
    this.props.shouldDialogOpen("dispatchOptimization");
  };
  openSetting = (e) => {
    this.props.openSettings(e, "/settings");
    this.props.closeMenu();
  };

  render() {
    const {
      isDataRefreshProgress,
      currentTerminalId,
      classes,
      openDriverChatBox,
      showDispatchNotificationsHeaderIcon,
      userData,
      onTerminalChange,
    } = this.props;
    this.disbaleDynamicRouting = isDataRefreshProgress;
    return (
      <div className={classes.mainMenuStyle}>
        <div className={`${classes.optymizeBtnContainer} ${classes.headerIconStyles}`}>
          <Tooltip title="Pickup Optymizer">
            <div className={this.disbaleDynamicRouting ? classes.disabledCursor : ''}>
              <Button
                onClick={this.openDynamicRoutingModal}
                variant="contained"
                color="primary"
                size="small"
                style={{ width: '140px' }}
                classes={{
                  root: classes.optymizeButtonStyle,
                  disabled: classes.disabledOptymizeBtn
                }}
                data-automationid="optimize-button">
                Pickup Optymizer
              </Button>
            </div>
          </Tooltip>
          <WatchTutorial
            componentId="PickupOptymizer"
            classes={{
              headerIconStyles: classes.optimyzerWatchTutorial
            }}
          />
        </div>
        <HelpMenu closeMenu={this.props.closeMenu} />
        <TerminalMenu
          currentTerminalId={currentTerminalId}
          userData={userData}
          onChange={onTerminalChange}
        />

        <div className={`${classes.muiIconContainer} ${classes.headerIconStyles}`}>
          <IconButton
            color="inherit"
            className={classes.muiIconButtonStyle}
            onClick={(e) => this.openSetting(e)}
            data-automationid="settings-icon">
            <Tooltip title="Application Settings">
              <SettingsIcon />
            </Tooltip>
          </IconButton>
        </div>
        {showDispatchNotificationsHeaderIcon && (
          <Notifications
            switchNotificationPanel={this.props.switchNotificationPanel}
            showNotification={this.props.showNotification}
            openDriverChatBox={openDriverChatBox}
          />
        )}
      </div>
    );
  }
}

export default withStyles(styles)(RightNavigationMenu);
